import { IAppEntity } from "../../entities";
import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { SettlementCustomerOpeningBalancesDetails } from "../../../components/Pages/Documents/SettlementCustomerOpeningBalances/SettlementCustomerOpeningBalancesDetail";
import SettlementCustomerOpeningBalancesList from "../../../components/Pages/Documents/SettlementCustomerOpeningBalances/SettlementCustomerOpeningBalancesList";
import { SettlementCustomerOpeningBalancesService } from "../../../services/documents/SettlementCustomerOpeningBalancesService";
import { CreateSettlementCustomerOpeningBalancesDto } from "../../../dtos/documents/SettlementCustomerOpeningBalances/CreateSettlementCustomerOpeningBalancesDto";
import { NFLookupSettlementCustomerOpeningBalances } from "../../../components/Shared/NewForms/NFLookupSettlementCustomerOpeningBalances";

export const SettlementCustomerOpeningBalances: IAppEntity = {
  entityType: "document",
  title: "Settlement Customer Opening Balances",
  pluralTitle: "Settlement Customer Opening Balances",
  apiUrl: "SettlementCustomerOpeningBalances",
  apiEnum: ReferenceTypes.DocumentSettlementCustomerOpeningBalance,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(SettlementCustomerOpeningBalancesDetails, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(SettlementCustomerOpeningBalancesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupSettlementCustomerOpeningBalances, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new SettlementCustomerOpeningBalancesService("SettlementCustomerOpeningBalances"),
  getEmptyModel: () => {
    const model: CreateSettlementCustomerOpeningBalancesDto = {
      status: 0,
      createdDate: new Date(),
      
      documentDate: new Date(),
      settlements:[]
    };
    return model;
  },
};
